<template>
  <v-form
    id="pass60"
    ref="uploadForm"
    v-model="uploadFormValid"
    lazy-validation
  >
    <div>
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">{{ selectedLang.UploadTile7 }}</h2>
          </div>
        </v-col>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2">
                  {{ uploadMeldung }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="kiofCla == 'TRF'" style="margin-top: -30px">
            <v-col cols="12">
              <div class="text-center">
                <v-chip class="ma-2" color="primary">
                  {{ chipTextPassenger }}
                </v-chip>
                <v-chip class="ma-2" color="primary">
                  {{ chipTextConnection }}
                </v-chip>
                <v-chip class="ma-2" color="primary">
                  {{ chipTextDates }}
                </v-chip>
                <v-chip class="ma-2" color="primary">
                  {{ chipTextRefund }}
                </v-chip>
                <v-chip v-if="chipTextAB != ''" class="ma-2" color="primary">
                  {{ chipTextAB }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-row class="tooltipbox tooltipbox-upload">
            <v-col cols="12">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    color="#022c54"
                    fab
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark> mdi-help </v-icon>
                  </v-btn>
                </template>
                <span v-html="selectedLang.UploadTile9b"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="showAlert">
              <v-alert
                v-model="wrongFF"
                close-text="Info schließen"
                type="error"
                dark
                dismissible
              ></v-alert
              >{{ selectedLang.UploadTile7a }}</v-col
            >
            <v-col cols="12">
              <v-checkbox
                v-model="rd4Upload"
                :disabled="pass60"
                :label="selectedLang.UploadTile8"
              ></v-checkbox>
            </v-col>
          </v-row>
          <template v-if="!rd4Upload">
            <v-row class="midwidth mr-auto ml-auto">
              <v-col v-if="uploadError" cols="12">
                <v-alert
                  v-model="uploadError"
                  prominent
                  dismissible
                  type="error"
                  >{{ errorText }}</v-alert
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <p class="h2calc2 m-0">{{ selectedLang.UploadTile18v2 }}</p>
              </v-col>
              <v-col cols="12" class="mb-5">
                <v-file-input
                  v-model="currFiles"
                  small-chips
                  accept="image/png, image/jpeg, image/jpg, application/pdf"
                  multiple
                  type="file"
                  id="currFiles"
                  ref="currFiles"
                  hide-input
                  :label="labelBS"
                  :disabled="pass60"
                  :rules="bsFileRules"
                  @change="inputChanged"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row v-if="files.length">
              <v-col cols="12" class="text-center"
                ><h3 class="text-center">{{ selectedLang.UploadTile16v2 }}</h3>
                <v-chip
                  class="ma-2 uchip"
                  v-for="(file, index) in files"
                  :key="file.name"
                  close
                  :disabled="pass60"
                  @click:close="close(index)"
                >
                  {{ file.name | removeMiddle }}
                </v-chip>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-row v-if="selectedDiv == '60'">
            <v-col cols="12">
              <v-btn
                :loading="loading"
                block
                class="btn-ep-next-step"
                @click="check60"
                >{{ selectedLang.UploadTile13 }}
                <v-icon right dark>mdi-cloud-upload</v-icon></v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="selectedDiv != '60' && !noChange">
            <v-col cols="12">
              <v-btn
                block
                class="btn-ep-back-to"
                @click="backToSpecificTile('60')"
                >{{ selectedLang.UploadTile14 }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-form>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  name: "ResultTile",
  data: function () {
    return {
      currFiles: [],
      files: [],
      rd4Upload: false,
      uploadFormValid: false,
      wrongFF: false,
      showAlert: false,
      labelBS: "",
      uploadLbSto: "",
      showULS: false,
      chipTextPassenger: "",
      chipTextConnection: "",
      chipTextDates: "",
      chipTextRefund: "",
      chipTextAB: "",
      errorText: "",
      uploadError: false,
      bsFileRules: [],
      loading: false,
    };
  },
  mounted: function () {
    this.labelBS = this.selectedLang.UploadTile9av2;
    this.bsFileRules = [
      (v) => !!v || this.$store.state.selectedLang.UploadTile3,
    ];
    if (this.kiofCla == "TRF") {
      if (this.user.companions.length) {
        this.chipTextPassenger = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ab,
          {
            "user.firstName": this.user.firstName,
            "user.lastName": this.user.lastName,
          }
        );
      } else {
        this.chipTextPassenger = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98aa,
          {
            "user.firstName": this.user.firstName,
            "user.lastName": this.user.lastName,
          }
        );
      }
      if (this.dataEP.rfFlN != undefined && this.dataEP.rfFlN != "") {
        this.chipTextConnection = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ad,
          {
            "dataFS.flN": this.dataFS.flN,
            "dataEP.rfFlN": this.dataEP.rfFlN,
          }
        );
        this.chipTextDates = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98af,
          {
            "dataFS.flD": this.dataFS.flD,
            "dataEP.sDRF": this.dataEP.sDRF,
          }
        );
      } else {
        this.chipTextConnection = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ac,
          {
            "dataFS.flN": this.dataFS.flN,
          }
        );
        this.chipTextDates = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ae,
          {
            "dataFS.flD": this.dataFS.flD,
          }
        );
      }
      if (this.dataEP.pKnown != "y") {
        this.chipTextRefund = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ag,
          {
            "dataEP.fullPrice": this.dataEP.fullPrice,
          }
        );
      } else {
        this.chipTextRefund = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ah,
          {
            "dataEP.refund": this.dataEP.refund,
          }
        );
      }
      if (this.user.ab) {
        this.chipTextAB = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile98ai,
          {
            "user.abfn": this.user.abfn,
            "user.abln": this.user.abln,
          }
        );
      }
    }
    if (this.selectedCase.valN == 3) {
      this.showULS = true;
      this.uploadLbSto = this.selectedLang.UploadTile10a;
    } else if (this.kiofCla == "NB" || this.kiofCla == "C" || this.anschFLS) {
      this.showULS = true;
      this.uploadLbSto = this.selectedLang.UploadTile10;
    } else {
      this.showULS = false;
    }
    let inputs = document.querySelectorAll(".v-file-input input");
    [...inputs].forEach((input) => {
      input.remove();
    });
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "kiofCla",
      "uploadMeldung",
      "pass60",
      "mdelay",
      "anschFLS",
      "selectedInfoAirline",
      "noChange",
      "selectedLang",
      "selectedCase",
      "user",
      "dataEP",
      "dataFS",
      "finalFormData",
    ]),
  },
  filters: {
    removeMiddle: function (value) {
      if (!value) return "";
      value = value.toString();
      if (value.length >= 23) {
        var part1 = value.substring(0, 10);
        var part2 = value.substring(value.length - 9);
        return part1 + "...." + part2;
      } else {
        return value;
      }
    },
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
    ]),
    inputChanged() {
      this.files = [...this.currFiles, ...this.files];
    },
    close(index) {
      this.files.splice(index, 1);
      if (!this.files.length) {
        this.currFiles = [];
      }
    },
    check60() {
      if (this.$refs.uploadForm.validate()) {
        if (!this.rd4Upload) {
          this.loading = true;
          let formData = new FormData();
          if (this.files.length) {
            for (var i = 0; i < this.files.length; i++) {
              let file = this.files[i];
              if (!this.sizeCheck(file.size)) {
                this.$refs.uploadForm.resetValidation();
                this.files = [];
                this.loading = false;
                this.uploadError = true;
                return false;
              } else {
                formData.append("files[" + i + "]", file);
              }
            }
          } else {
            this.$refs.uploadForm.resetValidation();
            this.uploadError = true;
            this.errorText = this.selectedLang.UploadTile17v2;
            this.loading = false;
            return false;
          }
          axios
            .post(
              "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/uploadIMGNew.php",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              if (response.data == "err") {
                this.wrongFF = true;
                this.showAlert = true;
              } else {
                this.setVar({ pos: "finalFormData", val: formData });
                this.loading = false;
                this.setSelectedDiv("70");
                this.$nextTick(() => {
                  this.goToStep({ vm: this, val: this.selectedDiv });
                });
                this.setVar({ pos: "pass60", val: true });
                this.setVar({ pos: "rd4Upload", val: this.rd4Upload });
                this.dataUploaded = true;
              }
            })
            .catch((error) => {
              this.errored = true;
              console.log(error);
            })
            .finally(() => (this.loading = false));
        } else {
          this.setSelectedDiv("70");
          this.$nextTick(() => {
            this.goToStep({ vm: this, val: this.selectedDiv });
          });
          this.setVar({ pos: "pass60", val: true });
          this.setVar({ pos: "rd4Upload", val: this.rd4Upload });
          this.dataUploaded = true;
        }
        this.$gtag.event("8. Upload bestaetigt", {
          event_category: "Rechner",
          event_label: "8. Upload bestaetigt",
        });
      }
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    sizeCheck(size) {
      let result = true;
      if (size < 1000) {
        result = false;
        this.errorText = this.selectedLang.KontoTile33;
      } else if (size > 10000000) {
        result = false;
        this.errorText = this.selectedLang.KontoTile35;
      }
      return result;
    },
  },
};
</script>
